import { useEffect, useState, useContext } from "react";
import { Grid, Card, CardContent, CardActions, Typography, Button, Stack, Box } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TopBarContext } from "../../providers/TopBarProvider";
import DownloaderReport from "../molecules/DownloaderReport";

const Dashboard = () => {
    const { setTitle, setSearchOptions, setBtnPrimary } =
        useContext(TopBarContext);

    const [showDownloader, setShowDownloader] = useState(false)
    const [reportType, setReportType] = useState("")

    const handleCloseDownloader = () => {
        setShowDownloader(false)
    }

    const generateAvailableProductsReport = (reportType) => {
        setReportType(reportType)
        setShowDownloader(true)
    }

    useEffect(() => {
        setTitle("Reportes");
        setSearchOptions({
          action: () => null,
          hidden: true,
        });
        setBtnPrimary({
          action: null,
        });
      }, [setTitle, setSearchOptions, setBtnPrimary]);

    return <>
        <Grid container spacing={2} mt="20px">
            <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ minWidth: 275, height: "100%" }}>
                    <Stack justifyContent={"space-between"} sx={{height: "100%"}}>
                        <CardContent>
                            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                                Reporte 1
                            </Typography>
                            <Typography variant="h5" component="div">
                                Productos disponibles
                            </Typography>
                            <Typography variant="body2" mt="8px">
                            Genera y descarga un reporte de todos los productos disponibles en el sistema, incluido su stock.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Stack flexGrow={1} direction="row" justifyContent="flex-end">
                                <Button color="warning" size="small" onClick={() => generateAvailableProductsReport("AvailableProductReport")}>
                                    Generar reporte
                                    <Box
                                        component={FontAwesomeIcon}
                                        icon="file-csv"
                                        fontSize="1rem"
                                        ml="8px"
                                    />
                                </Button>
                            </Stack>
                        </CardActions>
                    </Stack>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ minWidth: 275, height: "100%" }}>
                    <Stack justifyContent={"space-between"} sx={{height: "100%"}}>
                        <CardContent>
                            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                                Reporte 2
                            </Typography>
                            <Typography variant="h5" component="div">
                                Órdenes solicitadas
                            </Typography>
                            <Typography variant="body2" mt="8px">
                                Genera y descarga un reporte de todos los productos solicitados en cada orden, incluido su vendedor y cliente.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Stack flexGrow={1} direction="row" justifyContent="flex-end">
                                <Button color="warning" size="small" onClick={() => generateAvailableProductsReport("UserOrderReport")}>
                                    Generar reporte
                                    <Box
                                        component={FontAwesomeIcon}
                                        icon="file-csv"
                                        fontSize="1rem"
                                        ml="8px"
                                    />
                                </Button>
                            </Stack>
                        </CardActions>
                    </Stack>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ minWidth: 275, height: "100%" }}>
                    <Stack justifyContent={"space-between"} sx={{height: "100%"}}>
                        <CardContent>
                            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                                Reporte 3
                            </Typography>
                            <Typography variant="h5" component="div">
                                Stock Faltante
                            </Typography>
                            <Typography variant="body2" mt="8px">
                                Genera y descarga un reporte de todos los productos solicitados en cada orden con su stock y la cantidad faltante para cubrir con lo solicitado.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Stack flexGrow={1} direction="row" justifyContent="flex-end">
                                <Button color="warning" size="small" onClick={() => generateAvailableProductsReport("RestockReport")}>
                                    Generar reporte
                                    <Box
                                        component={FontAwesomeIcon}
                                        icon="file-csv"
                                        fontSize="1rem"
                                        ml="8px"
                                    />
                                </Button>
                            </Stack>
                        </CardActions>
                    </Stack>
                </Card>
            </Grid>
        </Grid>
        <DownloaderReport open={showDownloader} handleClose={handleCloseDownloader} reportType={reportType} />
    </>
}

export default Dashboard